// @core/api/endpoints/workflow/run_test_suite.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RunTestSuiteRequest,
  TestSuiteRunResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Run test suite
 * Executes all test cases in the suite and returns aggregated results.
 */
export async function RunTestSuite(
  test_suite_id: string,
  data: RunTestSuiteRequest,
  options?: RequestOptions
): Promise<TestSuiteRunResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/test-suites/:test_suite_id/run`;
  requestPath = requestPath.replace(':test_suite_id', encodeURIComponent(test_suite_id));
  const requestOptions = options;
  return client.post<TestSuiteRunResponse>(requestPath, data, requestOptions);
}
